export const MAP_CLASS = {
    RIDE: 'RIDE',
    SEARCH: 'SEARCH',
    BUILD: 'BUILD',
    EXPLORE: 'EXPLORE',
    PLAN: 'PLAN'
};

export const MAP_MODULES = {
    TOOLBAR: 'TOOLBAR',
    RIDE_MARKERS: 'RIDE_MARKERS',
    RIDE_TRACK: 'RIDE_TRACK',
    RIDE_POIS: 'RIDE_POIS',
    RIDE_STORE: 'RIDE_STORE',
    RIDE_SHARE: 'RIDE_SHARE',
    COMPUTE_ROAD: 'COMPUTE_ROAD',
    DRAW_LINE: 'DRAW_LINE',
    FREEHAND: 'FREEHAND',
    ELEVATION_COMPUTATION: 'ELEVATION_COMPUTATION',
    GRAPH: 'GRAPH',
    MARKER_VISIBILITY: 'MARKER_VISIBILITY',
    GEOLOCATION: 'GEOLOCATION',
    ISOCHRONE: 'ISOCHRONE',
    COLLABORATIVE: 'COLLABORATIVE'
};

export const ZOOM_SEARCH_LIMIT = 50;

// Passed to every map.setPaintProperty / setLayoutProperty / setFilter call. Without it,
// Style._validate serialises the WHOLE style on each call just to build the error context —
// quadratic wherever we loop over the style's layers (POI icon size, waymarked dimming, font
// scale). Since maplibre-gl 6.7 `validate: false` returns before that snapshot.
// Only use it with literal property names and values we compute ourselves, never user input.
export const STYLE_SETTER_OPTIONS = {validate: false};
